export function getStoragePrefix() {
  return localStorage.getItem('selectedLanguage') &&
    localStorage.getItem('selectedLanguage') !== 'hu'
    ? localStorage.getItem('selectedLanguage') + '/'
    : '';
}
